export const listByIdToArr = (obj, addId = d => d) =>
  Object.entries(obj)
    .reduce((acc, [id, d]) => [...acc, addId(d, id)], [])

export const listArrToById = (obj, getId = d => d.id) =>
  obj.reduce((acc, d) => ({ ...acc, [getId(d)]: d }), {})
